import React from 'react'
import { Link } from 'react-router-dom'

const Bread = ({title,sub,span}) => {
  return (
    <div className="container pb-20">
    <ol className="breadcrumb">
      <li>
        <Link to={"/"}>{title}</Link>
      </li>
      {sub &&
      <li>
        <Link>{sub}</Link >
      </li>}
      {span &&
        <li className="active">
        {span}
      </li>}
    </ol> 
  </div>
  )
}

export default Bread